import Dashboard from "@components/Account/Artist/Dashboard";

export default Dashboard;
